import {
    PIXELFORMAT_A8,
    PIXELFORMAT_L8,
    PIXELFORMAT_L8_A8,
    PIXELFORMAT_R5_G6_B5,
    PIXELFORMAT_R5_G5_B5_A1,
    PIXELFORMAT_R4_G4_B4_A4,
    PIXELFORMAT_R8_G8_B8,
    PIXELFORMAT_R8_G8_B8_A8,
    PIXELFORMAT_DXT1,
    PIXELFORMAT_DXT3,
    PIXELFORMAT_DXT5,
    PIXELFORMAT_RGB16F,
    PIXELFORMAT_RGBA16F,
    PIXELFORMAT_RGB32F,
    PIXELFORMAT_RGBA32F,
    PIXELFORMAT_R32F,
    PIXELFORMAT_DEPTH,
    PIXELFORMAT_DEPTHSTENCIL,
    PIXELFORMAT_111110F,
    PIXELFORMAT_SRGB,
    PIXELFORMAT_SRGBA,
    PIXELFORMAT_ETC1,
    PIXELFORMAT_ETC2_RGB,
    PIXELFORMAT_ETC2_RGBA,
    PIXELFORMAT_PVRTC_2BPP_RGB_1,
    PIXELFORMAT_PVRTC_2BPP_RGBA_1,
    PIXELFORMAT_PVRTC_4BPP_RGB_1,
    PIXELFORMAT_PVRTC_4BPP_RGBA_1,
    PIXELFORMAT_ASTC_4x4,
    PIXELFORMAT_ATC_RGB,
    PIXELFORMAT_ATC_RGBA,
    TEXTURETYPE_DEFAULT,
    TEXTURETYPE_RGBM,
    TEXTURETYPE_RGBE,
    TEXTURETYPE_RGBP,
    TEXTURETYPE_SWIZZLEGGGR
} from 'playcanvas';

const PixelFormatTable = {
    [PIXELFORMAT_A8]: 'A8',
    [PIXELFORMAT_L8]: 'L8',
    [PIXELFORMAT_L8_A8]: 'LA8',
    [PIXELFORMAT_R5_G6_B5]: 'RGB565',
    [PIXELFORMAT_R5_G5_B5_A1]: 'RGBA5551',
    [PIXELFORMAT_R4_G4_B4_A4]: 'RGBA4444',
    [PIXELFORMAT_R8_G8_B8]: 'RGB8',
    [PIXELFORMAT_R8_G8_B8_A8]: 'RGBA8',
    [PIXELFORMAT_DXT1]: 'DXT1',
    [PIXELFORMAT_DXT3]: 'DXT3',
    [PIXELFORMAT_DXT5]: 'DXT5',
    [PIXELFORMAT_RGB16F]: 'RGB16F',
    [PIXELFORMAT_RGBA16F]: 'RGBA16F',
    [PIXELFORMAT_RGB32F]: 'RGB32F',
    [PIXELFORMAT_RGBA32F]: 'RGBA32F',
    [PIXELFORMAT_R32F]: 'R32F',
    [PIXELFORMAT_DEPTH]: 'DEPTH',
    [PIXELFORMAT_DEPTHSTENCIL]: 'DEPTHSTENCIL',
    [PIXELFORMAT_111110F]: '111110F',
    [PIXELFORMAT_SRGB]: 'SRGB',
    [PIXELFORMAT_SRGBA]: 'SRGBA',
    [PIXELFORMAT_ETC1]: 'ETC1',
    [PIXELFORMAT_ETC2_RGB]: 'ETC2_RGB',
    [PIXELFORMAT_ETC2_RGBA]: 'ETC2_RGBA',
    [PIXELFORMAT_PVRTC_2BPP_RGB_1]: 'PVRTC_2',
    [PIXELFORMAT_PVRTC_2BPP_RGBA_1]: 'PVRTC_2_A',
    [PIXELFORMAT_PVRTC_4BPP_RGB_1]: 'PVRTC_4',
    [PIXELFORMAT_PVRTC_4BPP_RGBA_1]: 'PVRTC_4_A',
    [PIXELFORMAT_ASTC_4x4]: 'ASTC_4X4',
    [PIXELFORMAT_ATC_RGB]: 'ATC',
    [PIXELFORMAT_ATC_RGBA]: 'ATC_A'
};

const TextureTypeTable = {
    [TEXTURETYPE_DEFAULT]: 'default',
    [TEXTURETYPE_RGBM]: 'rgbm',
    [TEXTURETYPE_RGBE]: 'rgbe',
    [TEXTURETYPE_RGBP]: 'rgbp',
    [TEXTURETYPE_SWIZZLEGGGR]: 'swizzleGGGR'
};

export {
    PixelFormatTable,
    TextureTypeTable
};
